// Things placed in zones that both sides need to know about. The server decides what happens; the client draws them.

/** Forage spots: walk up, press E, and the server decides whether you find something. Each character has its own timer per spot. */
export interface ForageNode { id: string; map: string; tile: [number, number]; item: string; qty: [number, number]; respawnSec: number;
  /** Only there at night, or while it rains and for a while after. */
  when?: 'night' | 'rain' }

export const FORAGE: ForageNode[] = [
  { id: 'town-mush-1', map: 'town', tile: [6, 10], item: 'mushroom', qty: [1, 2], respawnSec: 90 },
  { id: 'town-mush-2', map: 'town', tile: [5, 16], item: 'mushroom', qty: [1, 2], respawnSec: 90 },
  { id: 'town-herb-1', map: 'town', tile: [14, 23], item: 'herb', qty: [1, 3], respawnSec: 120 },
  { id: 'town-herb-2', map: 'town', tile: [24, 24], item: 'herb', qty: [1, 3], respawnSec: 120 },
  { id: 'town-flower-1', map: 'town', tile: [30, 9], item: 'flower', qty: [1, 1], respawnSec: 150 },
  { id: 'town-apple-1', map: 'town', tile: [37, 11], item: 'apple', qty: [1, 2], respawnSec: 120 },
  // night: moonflowers open by the flower beds and the pond
  { id: 'town-moon-1', map: 'town', tile: [33, 9], item: 'moonflower', qty: [1, 1], respawnSec: 120, when: 'night' },
  { id: 'town-moon-2', map: 'town', tile: [15, 20], item: 'moonflower', qty: [1, 1], respawnSec: 120, when: 'night' },
  { id: 'town-moon-3', map: 'town', tile: [25, 21], item: 'moonflower', qty: [1, 1], respawnSec: 120, when: 'night' },
  // rain: rain caps pop up in the shade after a shower
  { id: 'town-rain-1', map: 'town', tile: [2, 11], item: 'rain_cap', qty: [1, 2], respawnSec: 100, when: 'rain' },
  { id: 'town-rain-2', map: 'town', tile: [10, 15], item: 'rain_cap', qty: [1, 2], respawnSec: 100, when: 'rain' },
  { id: 'town-rain-3', map: 'town', tile: [37, 17], item: 'rain_cap', qty: [1, 2], respawnSec: 100, when: 'rain' },
];

/** How close (pixels, feet to spot centre) you must be to pick something. */
export const INTERACT_RANGE_PX = 22;
